import Box from '~/core/Box'
import { getenv } from '~/settings'
export const isProduction = getenv('IS_PROD') === 'true'

const FEEDBACK_URL = isProduction
    ? 'https://fictiv.com/request-premium-access'
    : 'https://fictivstaging.wpengine.com/request-premium-access'

const UpsellForm = () => {
    return (
        <Box height="100%">
            <iframe
                src={`${FEEDBACK_URL}`}
                style={{
                    border: 0,
                    height: '100%',
                    width: '100%',
                    borderRadius: '4px',
                }}
            />
        </Box>
    )
}

export default UpsellForm
